import Base from './Base';

export default class Notification extends Base {
  id = 0;
  workspace = null;
  content = '';
  case = '';
  createdAt;
  read = false;

  constructor(source) {
    super();
    this.clone(source);
  }
}
